module.exports = __webpack_public_path__ + "img/05.ea16a700.jpg";